export default __webpack_public_path__ + "static/media/headBack.5db5b122.jpg";